import { normalize, schema } from 'normalizr'

// QUIZ
const questionSchema = new schema.Entity('question')
const questionsSchema = new schema.Array(questionSchema)

const quizSchema = new schema.Entity('quiz', { questions: questionsSchema })
const quizzesSchema = new schema.Array(quizSchema)

export function normalizeQuizzes(quizzes) {
  return normalize(quizzes, quizzesSchema)
}

// THEMES
const lessonSchema = new schema.Entity('lesson')
const lessonsSchema = new schema.Array(lessonSchema)

const lessonStepSchema = new schema.Entity('lessonStep', { lessons: lessonsSchema })
const lessonStepsSchema = new schema.Array(lessonStepSchema)

const tastingQuestionSchema = new schema.Entity('tastingQuestion')
const tastingTransitionSchema = new schema.Entity('tastingTransition')

const tastingQuestionsAndTransitionsSchema = new schema.Array(
  {
    tastingQuestions: tastingQuestionSchema,
    tastingTransitions: tastingTransitionSchema
  },
  input => (input.contentType === 'tastingQuestion' ? 'tastingQuestions' : 'tastingTransitions')
)

const tastingSchema = new schema.Entity('tasting', {
  aromaScreens: tastingQuestionsAndTransitionsSchema,
  conclusionScreens: tastingQuestionsAndTransitionsSchema,
  eyeScreens: tastingQuestionsAndTransitionsSchema,
  introductionScreens: tastingQuestionsAndTransitionsSchema,
  mouthScreens: tastingQuestionsAndTransitionsSchema,
  noseScreens: tastingQuestionsAndTransitionsSchema
})
const tastingsSchema = new schema.Array(tastingSchema)

const themeSchema = new schema.Entity('theme', {
  lessonSteps: lessonStepsSchema,
  tastings: tastingsSchema
})
const themesSchema = new schema.Array(themeSchema)

export function normalizeThemes(themes) {
  return normalize(themes, themesSchema)
}
